// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".key-copy[data-v-5a97e180]{background-color:#d3d3d3;border:1px solid #a9a9a9;color:gray;cursor:pointer;height:80px;margin-left:auto;margin-right:auto;margin-top:10px;max-width:443px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
